export default "__VITE_ASSET__ebb813a8__"